import styled from '@emotion/styled';

export const PageTitleActions = styled.div`
    display: block;
`;
